import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { map } from 'rxjs/operators';
import { PracticeSetupStepValidation } from './practice-setup-step-validation';
import {
  IPageVisitTrackingConfig,
  IPracticeSetupStepDefinition,
} from './practice-setup-step.types';
import { initRawSchema, toParagraphContent } from '@principle-theorem/editor';

const pageVisitTracking: IPageVisitTrackingConfig = {
  routes: ['settings/brand/{brandId}/document-templates'],
  validationMode: 'any',
};

export const documentTemplatesStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.DocumentTemplates,
  category: PracticeSetupStepCategory.AdditionalSettings,
  title: 'Set Up Your Document Templates',
  description: initRawSchema([
    toParagraphContent(
      `The Document Templates page is where you manage the templates used for printed and digital documents generated through Principle. This includes configuring the headers and footers on standard documents such as invoices and treatment plans, as well as creating reusable templates for documents your team produces on a regular basis.`
    ),
    toParagraphContent(
      `Having your templates set up before launch ensures that every document leaving your practice looks professional and consistent from day one.`
    ),
  ]),
  dependsOn: [],
  getRoute: (brand, _practice) =>
    `settings/brand/${brand.ref.id}/document-templates`,
  validate$: (practice$, step, options) => {
    return practice$.pipe(
      map((_practice) => {
        if (options?.reviewed || options?.skipped) {
          return { valid: true };
        }

        const pageVisitValidation =
          PracticeSetupStepValidation.validatePageVisits(
            step,
            pageVisitTracking
          );
        if (pageVisitValidation.valid) {
          return { valid: true };
        }

        return {
          valid: false,
          reason: 'Please review this page to complete this step',
        };
      })
    );
  },
  pageVisitTracking,
};
